export const SET_MODAL = "SET_MODAL";
export const SET_NAV_WIDTH = "SET_NAV_WIDTH";
export const SET_NAV_HIDE = "SET_NAV_HIDE";
export const SET_PREVIEW = "SET_PREVIEW";
export const SET_PAGE = "SET_PAGE";
export const SET_HIDE_FOOTER = "SET_HIDE_FOOTER";
export const CLEAR_STORE = "CLEAR_STORE";
export const SET_STORE_VERSION = "SET_STORE_VERSION";
